import React from 'react';
import { connect } from 'react-redux';
import {
  reduxForm, formValueSelector, change, isPristine, isInvalid
} from 'redux-form';
import _ from 'lodash';
import { selectPathologist } from '../../redux/actions';
import { setCadessAnalysisForValidation } from '../../helpers/cadessValidationHelper';
import SpecimenAnalysisComponent from './SpecimenAnalysisComponent';
import CaseAnalysisComponent from './CaseAnalysisComponent';
import unavailibleFormFallback from '../shared/unavalibleFormFallback';
import validate from '../../helpers/validateCaseSpecimenForm';
import { userRoles, caseStatus } from '../../constants';



let CaseAndSpecimenAnalysisForm = ({
  // from redux
  getFieldValue,
  numberOfCores,
  unavailable,
  userRole,
  specimenId,
  isCaseLevel,
  analysisMarkedAsDone,
  containsUnsavedChanges,
  submitAllButtonProps,
  formShouldBeDisabled,
  pathologistName,
  markAnalyzeesDoneWarningText,
  disableSaveAllButton,
  caseIsSubmittedDemo,
  // from redux form 
  pristine,
  submitting,
  handleSubmit,
  invalid,
  setFieldValue,
  // from parent
  formSubmit,
  handleSubmitAllDemo,
  handleMarkAsDone,
  handleSaveAndGoToNext,
  saveAllUnsavedSpecimenAnalyzes,
  goBackToStatusAwaitingAnalysis,
}) => {
  const caseAndSpecimenAnalysisProps = {
    userRole,
    getFieldValue,
    numberOfCores,
    analysisMarkedAsDone,
    pristine,
    submitting,
    handleMarkAsDone,
    handleSaveAndGoToNext,
    invalid,
    setFieldValue,
    containsUnsavedChanges,
    pathologistName,
  };
  if (unavailable) {
    return (
      <>
        {unavailibleFormFallback('No available analyses')}
        <br />
      </>
    );
  }
  return (
    <fieldset>
      {isCaseLevel ? (
        <form
          onSubmit={handleSubmit(formSubmit)}
          className="form case-specimen-form case-form"
        >
          <CaseAnalysisComponent
            {...caseAndSpecimenAnalysisProps}
            submitAllButtonProps={submitAllButtonProps}
            markAnalyzeesDoneWarningText={markAnalyzeesDoneWarningText}
            disableSaveAllButton={disableSaveAllButton}
            handleSubmitAllDemo={handleSubmitAllDemo}
            saveAllUnsavedSpecimenAnalyzes={saveAllUnsavedSpecimenAnalyzes}
            goBackToStatusAwaitingAnalysis={goBackToStatusAwaitingAnalysis}
            caseIsSubmittedDemo={caseIsSubmittedDemo}
            formShouldBeDisabled={formShouldBeDisabled}
          />
          <div style={{clear: 'both'}}><br/></div>
          <i style={{paddingBottom: '20px'}}>The source of this form is the International Collaboration on Cancer Reporting. 2017. Prostate Core Needle Biopsy Histopathology Reporting Guide 1st edition. Sydney, Australia. ISBN: 978-1-925687-10-1.</i>
        </form>
      )
        : (
          <form
            onSubmit={handleSubmit(formSubmit)}
            className="form case-specimen-form specimen-form"
          >
            <SpecimenAnalysisComponent {...caseAndSpecimenAnalysisProps} specimenId={specimenId} />
            <div style={{clear: 'both'}}></div>
            <i style={{paddingBottom: '20px'}}>The source of this form is the International Collaboration on Cancer Reporting. 2017. Prostate Core Needle Biopsy Histopathology Reporting Guide 1st edition. Sydney, Australia. ISBN: 978-1-925687-10-1.</i>
          </form>
        )
      }
    </fieldset>
  );
};


CaseAndSpecimenAnalysisForm = reduxForm({
  //form: 'caseSpecimenForm',
  //destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: true,
  validate,
})(CaseAndSpecimenAnalysisForm);


const mapDispatchToProps = (dispatch, ownProps) => ({
  setFieldValue: (field, value) => {
    dispatch(change(ownProps.form, field, value));
  },
  selectPathologist: pathologist => dispatch(selectPathologist(pathologist)),

});

const mapStateToProps = (state, ownProps) => {
  const { user } = state.auth;
  const {
    currentPathologist,
    selectedSpecimen,
    selectedCase,
    specimens,
    unsavedAnalyzes,
  } = state._case;
  const { CADESSAnalysis } = state.cadessData;
  const selector = formValueSelector(ownProps.form);
  const formId = ownProps.form;
  setCadessAnalysisForValidation(CADESSAnalysis);
  const getFieldValue = (fieldName) => selector(state, fieldName);
  const isCaseLevel = _.isEmpty(state._case.selectedSpecimen);
  const pristine = isPristine(ownProps.form)(state);
  const currentValuesisInvalid = isInvalid(ownProps.form)(state);
  const userRole = user.role;
  const specimenId = selectedSpecimen.id;
  let { initValues } = ownProps;
  let unavailable = false;
  let analysisMarkedAsDone = false;
  let numberOfCores;
  const containsUnsavedChanges = unsavedAnalyzes.some(analysis => analysis.formId === formId);
  const someFormHasUnsavedChanges = unsavedAnalyzes.length > 0;
  const { someFormIsInvalid } = selectedCase;
  let submitAllButtonProps = {};
  const { workFlowStatusDemo: { AWAITING_ANALYSIS, ANALYSIS_SUBMITTED } } = caseStatus;
  const currentCaseStatus = selectedCase.status.workFlowStatusDemo;
  if (_.isEmpty(currentPathologist)) {
    unavailable = true;
    return { unavailable };
  }

  let markAnalyzeesDoneWarningText = '';
  const disableSaveAllButton = !(someFormHasUnsavedChanges || !pristine);
  if (isCaseLevel) {
    numberOfCores = specimens
      .filter(s => selectedCase.specimens.includes(s._id))
      .reduce(((total, specimen) => total + specimen.totalNumberOfCores), 0);

    if (someFormIsInvalid || someFormIsInvalid === undefined || currentValuesisInvalid) {
      markAnalyzeesDoneWarningText += 'Some form has missing/invalid values.';
    }

    if ((someFormHasUnsavedChanges || !pristine)) {
      submitAllButtonProps = {
        disabled: true,
        title: 'Some form has unsaved changes',
      };
    } else if (currentCaseStatus !== AWAITING_ANALYSIS) {
      submitAllButtonProps = {
        disabled: true,
        title: `Can't submit case with status "${currentCaseStatus}"`,
      };
    } else if (!getFieldValue('termsAgreement')) {
      submitAllButtonProps = {
        disabled: true,
        title: 'Terms of agreement needs to be accepted',
      };
    } else {
      submitAllButtonProps = {
        disabled: false,
        title: 'Marks all forms (specimen and case level analyzes) as done',
      };
    }
  } else {
    numberOfCores = selectedSpecimen.totalNumberOfCores;

    try {
      analysisMarkedAsDone = selectedSpecimen
        .analyses
        .find(a => a.assignee === currentPathologist._id)
        .validationComplete;
    } catch (e) {
      analysisMarkedAsDone = false;
    }
  }
  const formShouldBeDisplayed = (initValues !== null && !_.isEmpty(initValues))
    || (user.role === userRoles.admin && !_.isEmpty(currentPathologist))
    || user._id === currentPathologist._id;

  const caseIsSubmittedDemo = currentCaseStatus === ANALYSIS_SUBMITTED;
  const formShouldBeEnabled = (currentCaseStatus === AWAITING_ANALYSIS && user.role === userRoles.pathologist) || user.role === userRoles.admin;
  if (initValues === null) {
    initValues = {};
  }

  unavailable = !formShouldBeDisplayed;
  return {
    initialValues: initValues,
    unavailable,
    analysisMarkedAsDone,
    userRole,
    specimenId,
    getFieldValue,
    numberOfCores,
    isCaseLevel,
    pristine,
    containsUnsavedChanges,
    submitAllButtonProps,
    formShouldBeDisabled: !formShouldBeEnabled,
    pathologistName: currentPathologist.name,
    markAnalyzeesDoneWarningText,
    disableSaveAllButton,
    caseIsSubmittedDemo,

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseAndSpecimenAnalysisForm);
